import { CancelOutlined as CancelOutlinedIcon } from '@mui/icons-material';
import type { FunctionComponent } from 'react';

import type { InteractiveChipProps } from './InteractiveChip';
import { InteractiveChip } from './InteractiveChip';

export const RemovableChip: FunctionComponent<Omit<InteractiveChipProps, 'icon'>> = ({
    isActive = false,
    label,
    onDelete,
}) => (
    <InteractiveChip
        icon={<CancelOutlinedIcon fontSize="small" />}
        isActive={isActive}
        label={label}
        onDelete={onDelete}
    />
);
